import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

const EmptyList = () => (
  <Box
    borderRadius={{
      all: 'abs008',
    }}
    border={{
      all: {
        width: 's1',
        style: 'solid',
        color: 'grey400',
      },
    }}
    padding="s24"
    textAlign="center"
  >
    <Text.Normal>{i18n.t('documents.document_templates.list.empty_description')}</Text.Normal>
  </Box>
)

export default observer(EmptyList)
